import { EmptystateDataFlowColored } from "components/icons/generated";
import EmptyState from "ds/components/EmptyState";
import useErrorHandle from "hooks/useErrorHandle";
import useSearchIntentResourcesOperations from "shared/IntentProject/useSearchIntentResourcesOperations";
import useSearchIntentResourcesOperationsSuggestions from "shared/IntentProject/useSearchIntentResourcesOperationsSuggestions";
import { IntentProject } from "types/generated";
import useTitle from "hooks/useTitle";

import IntentProjectOperationsTable from "./Table";
import { EMPTY_STATE_CAPTION } from "./constants";
import IntentProjectOperationLogFiltersLayout from "./FiltersLayout";

type IntentProjectHistoryProps = {
  intentProject: IntentProject;
};

const IntentProjectHistory = ({ intentProject }: IntentProjectHistoryProps) => {
  useTitle(`History · ${intentProject.name}`);

  const {
    operations,
    loadingContent,
    isEmpty,
    error,
    startCursor,
    endCursor,
    paginationResetKey,
  } = useSearchIntentResourcesOperations(intentProject.id);

  const { filteredCount } = useSearchIntentResourcesOperationsSuggestions(intentProject.id);

  const ErrorContent = useErrorHandle(error);

  if (ErrorContent) {
    return ErrorContent;
  }

  return (
    <IntentProjectOperationLogFiltersLayout intentProjectId={intentProject.id}>
      {isEmpty && (
        <EmptyState
          title="No operations found"
          caption={EMPTY_STATE_CAPTION}
          icon={EmptystateDataFlowColored}
        />
      )}

      {!isEmpty && (
        <IntentProjectOperationsTable
          operations={operations}
          loading={loadingContent}
          startCursor={startCursor}
          endCursor={endCursor}
          allItemsCount={filteredCount}
          resetKey={paginationResetKey}
        />
      )}
    </IntentProjectOperationLogFiltersLayout>
  );
};

export default IntentProjectHistory;
